import { useCallback } from "react";
import {
  RegisterOptions,
  useController,
  Control,
  FieldValues,
  Path,
} from "react-hook-form";
import Textarea from "@components/Textarea";

interface TextAreaContainerProps<TFieldValues extends FieldValues> {
  control: Control<TFieldValues>;
  name: Path<TFieldValues>;
  rules?: Omit<
    RegisterOptions<TFieldValues>,
    "valueAsNumber" | "valueAsDate" | "setValueAs" | "disabled"
  >;
  title: string;
  rows?: number;
  disabled?: boolean;
  maxLength?: number;
  onChange?: (v: string) => string;
}

const TextAreaContainer = <TFieldValues extends FieldValues = FieldValues>(
  props: TextAreaContainerProps<TFieldValues>,
) => {
  const { field, fieldState } = useController<TFieldValues>({
    control: props.control,
    name: props.name,
    rules: props.rules,
  });

  const handleOnChange = useCallback((v: string) => {
    return props.onChange
      ? field.onChange(props.onChange(v)) 
      : field.onChange(v);
  }, [props.onChange]);

  return (
    <Textarea
      value={field.value}
      onChange={handleOnChange}
      name={field.name}
      title={props.title}
      errorMessage={fieldState.error?.message}
      hasError={!!fieldState.error}
      rows={props.rows}
      disabled={props.disabled}
      maxLength={props.maxLength ?? 1000}
    />
  );
};

export default TextAreaContainer;
